import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function RelatedArticles() {
  const { t } = useTranslation();

  const articles = t("relatedArticles.articles", { returnObjects: true });

  return (
    <div className="container my-4">
      <h5 className="fw-bold mb-3">{t("relatedArticles.title")}</h5>
      <div className="d-flex flex-wrap gap-2">
        {articles.map((article, index) => (
          <Link
            key={index}
            to={article.link}
            className="badge bg-light text-dark border"
            style={{ cursor: "pointer", fontSize: "12px" }}
          >
            #{article.name}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default RelatedArticles;
